import fetchUserIsLogged from '~~/modules/api/rurality/v3/user/is-logged'
import { useUserStore } from '~~/modules/auth/stores/userStore'

export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.server) return

  const getUserData = async () => {
    try {
      const authUserIsLogged = await fetchUserIsLogged()
      const userStore = useUserStore()
      userStore.setUser(authUserIsLogged)
    } catch (error) {
      console.error('Failed to fetch user data:', error)
    }
  }

  // Set up event listeners immediately but defer initial data fetch
  document.addEventListener('GoogleIdentityService:userSignedIn', getUserData)
  const removeListener = () => {
    document.removeEventListener(
      'GoogleIdentityService:userSignedIn',
      getUserData,
    )
  }
  window.addEventListener('pagehide', removeListener, { once: true })

  // Defer initial user data fetch to not block render
  const nuxtApp = useNuxtApp()

  nuxtApp.hook('page:loading:end', async () => {
    getUserData()
  })

  return
})
